import React from 'react';
import { motion } from 'framer-motion';
import { Droplets, Leaf, Shield } from 'lucide-react';
export function MechanismSection() {
  const pillars = [{
    icon: <Droplets size={32} className="text-botanical-gold" data-id="element-122" />,
    title: 'Apertura',
    desc: 'Preparación del poro con sales específicas para receptividad máxima.'
  }, {
    icon: <Leaf size={32} className="text-botanical-gold" data-id="element-123" />,
    title: 'Infusión',
    desc: 'Entrada de activos botánicos puros directamente a la dermis.'
  }, {
    icon: <Shield size={32} className="text-botanical-gold" data-id="element-124" />,
    title: 'Sellado',
    desc: 'Protección de la barrera cutánea para retener la hidratación.'
  }];
  return <section className="py-24 px-4 bg-botanical-forest text-botanical-ivory relative overflow-hidden" data-id="element-125">
      {/* Decorative subtle background */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(circle at center, #C4973B 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-126"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-128">
          <h2 className="text-4xl md:text-5xl font-playfair text-botanical-gold mb-6" data-id="element-129">
            El Método del Triángulo Maestro
          </h2>
          <p className="text-lg md:text-xl font-lora text-botanical-ivory/80 leading-relaxed" data-id="element-130">
            Esta guía no es solo un recetario; es un sistema de tres pilares. Es
            la diferencia entre simplemente "ponerse algo" y realizar un
            tratamiento de grado alquímico en tu propia casa.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 relative" data-id="element-131">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-1/6 right-1/6 h-px bg-botanical-gold/30 -translate-y-1/2 z-0" data-id="element-132"></div>

          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-botanical-forest-dark p-8 rounded-sm border border-botanical-gold/20 relative z-10 text-center group hover:border-botanical-gold/50 transition-colors duration-300" data-id="element-133">
              <div className="w-16 h-16 mx-auto bg-botanical-forest rounded-full flex items-center justify-center mb-6 border border-botanical-gold/30 group-hover:scale-110 transition-transform duration-300" data-id="element-134">
                {pillar.icon}
              </div>
              <h3 className="text-2xl font-playfair text-botanical-ivory mb-4" data-id="element-135">
                {pillar.title}
              </h3>
              <p className="text-botanical-ivory/70 font-lora leading-relaxed" data-id="element-136">
                {pillar.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}